'use strict';

const isParentalConsentNeeded = (birthday, limitAge) => {
    const birthdaySplitValue = birthday.split(/[.,\/ -]/);
    const currentCountryCode = util.getCountryFromLocaleCookie();

    const day = currentCountryCode === 'US' ? birthdaySplitValue[1] : birthdaySplitValue[0];
    const month = currentCountryCode === 'US' ? birthdaySplitValue[0] : birthdaySplitValue[1];
    const year = currentCountryCode === 'US' || !birthdaySplitValue[2] ? 1900 : parseInt(birthdaySplitValue[2]);
    const dob = new Date(year, parseInt(month) - 1, day);

    const limitDate = new Date();
    limitDate.setFullYear(limitDate.getFullYear() - limitAge);

    return dob > limitDate;
};

module.exports = isParentalConsentNeeded;
